/**
 * PAPPO — Stickers Service
 * Busca figurinhas no backend (que consulta o Giphy com rating forçado) e
 * "escolhe" uma figurinha, que o backend rehospeda em /uploads e devolve como
 * um attachment_url interno — pronto para enviar via socket como imagem.
 */

import { apiGet, apiPost } from './api';

/** Item de figurinha devolvido pela busca (miniatura para o seletor) */
export interface StickerResult {
  id: string;
  preview_url: string;
  title: string;
  width?: string;
  height?: string;
}

/** Busca figurinhas por termo (vazio → figurinhas em alta) */
export async function searchStickers(query: string) {
  const q = encodeURIComponent(query.trim());
  return apiGet<{ stickers: StickerResult[] }>(`/stickers/search?q=${q}`);
}

/** Figurinhas em alta (usadas ao abrir o seletor sem busca) */
export async function getTrendingStickers() {
  return apiGet<{ stickers: StickerResult[] }>('/stickers/trending');
}

/**
 * Escolhe uma figurinha: o backend baixa e rehospeda em /uploads, devolvendo
 * o attachment_url interno (mesmo formato do upload de imagem).
 */
export async function pickSticker(id: string) {
  return apiPost<{ attachment_url: string; message_type: 'sticker' }>(
    '/stickers/pick',
    { id }
  );
}
